import { getCookie } from './cookies';
import { isWebView } from './webView';

export const APP_ACCESS_TOKEN_COOKIE_NAME = 'app_access_token';
const APP_ACCESS_TOKEN_SESSION_KEY = 'appAccessToken';

let appAccessTokenMemory: string | null = null;

const readPersistedAppAccessToken = (): string | null => {
  try {
    return sessionStorage.getItem(APP_ACCESS_TOKEN_SESSION_KEY);
  } catch {
    return null;
  }
};

const persistAppAccessToken = (token: string) => {
  appAccessTokenMemory = token;
  try {
    if (sessionStorage.getItem(APP_ACCESS_TOKEN_SESSION_KEY) !== token) {
      sessionStorage.setItem(APP_ACCESS_TOKEN_SESSION_KEY, token);
    }
  } catch {
    // WebView may block storage; in-memory value covers the current load
  }
};

export const getAppAccessToken = (): string | null => {
  if (!isWebView()) return null;

  const fromCookie = getCookie(APP_ACCESS_TOKEN_COOKIE_NAME);
  if (fromCookie) {
    persistAppAccessToken(fromCookie);
    return fromCookie;
  }

  if (appAccessTokenMemory) return appAccessTokenMemory;

  const persisted = readPersistedAppAccessToken();
  if (persisted) {
    appAccessTokenMemory = persisted;
    return persisted;
  }

  return null;
};

export const captureAppAccessToken = (): string | null => {
  if (!isWebView()) return null;

  const fromCookie = getCookie(APP_ACCESS_TOKEN_COOKIE_NAME);
  if (fromCookie) persistAppAccessToken(fromCookie);

  return getAppAccessToken();
};
